<template>
  <div class="invoiceTitle_page">
    <div class="title_box flex_center">
      <img src="./image/order_icon3.png" class="order_icon" />
      <div class="flex_column">
        <div class="order_title">发票抬头管理</div>
        <div class="order_subtitle"></div>
      </div>
    </div>
    <div class="filter_content font">
      <span class="order_subtitle">状态：</span>
      <el-select
        v-model="filterData.verifyStatus"
        placeholder="请选择"
        class="mr12 width150"
        size="small"
      >
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-button
        style="background-color: #00a0e9; color: #ffffff; border-color: #00a0e9"
        size="small"
        @click="getInfo(1)"
      >
        查询</el-button
      >
    </div>
    <div class="content_box">
      <div class="table_content">
        <el-table :data="tableData" style="width: 100%; max-width: 1200px" v-loading="loading">
          <el-table-column prop="companyName" label="公司名"> </el-table-column>
          <el-table-column prop="licenseCode" label="社会信用代码">
          </el-table-column>
          <el-table-column prop="companyAddress" label="公司地址">
          </el-table-column>
          <el-table-column prop="bankPhone" label="电话"> </el-table-column>
          <el-table-column prop="bankName" label="开户银行"> </el-table-column>
          <el-table-column prop="bankCard" label="银行账号"> </el-table-column>
          <el-table-column prop="verifyStatus" label="审核状态">
            <template slot-scope="scope">
              <div>
                {{
                  $enums.verifyStatusEnum.getLabelByValue(
                    scope.row.verifyStatus
                  )
                }}
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column label="操作">
            <template slot-scope="scope">
              <div class="flex_center">
                <el-button
                  type="text"
                  class="mr12 price"
                  @click="toEdit(scope.row)"
                  >编辑</el-button
                >
              </div>
            </template>
          </el-table-column> -->
        </el-table>
        <div class="flex_end statics" v-if="pageInfo.total > 10">
          <el-pagination
            :current-page.sync="pageInfo.pageNo"
            :page-size="pageInfo.pageSize"
            layout="total, prev, pager, next"
            :total="pageInfo.total"
            @current-change="changePage"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <el-dialog title="编辑发票抬头" :visible.sync="addModel.flag" width="520">
      <div>
        <el-form
          ref="ruleForm"
          :model="addModel"
          label-width="150px"
          :rules="rules"
        >
          <el-form-item label="公司名" prop="companyName">
            <el-input
              v-model="addModel.companyName"
              placeholder="请输入公司名"
            ></el-input>
          </el-form-item>
          <el-form-item label="社会统一信用代码" prop="licenseCode">
            <el-input
              v-model="addModel.licenseCode"
              placeholder="请输入社会统一信用代码"
            ></el-input>
          </el-form-item>
          <el-form-item label="公司地址" prop="companyAddress">
            <el-input
              v-model="addModel.companyAddress"
              placeholder="请输入公司地址"
            ></el-input>
          </el-form-item>
          <el-form-item label="开户银行" prop="bankName">
            <el-input
              v-model="addModel.bankName"
              placeholder="请输入开户银行"
            ></el-input>
          </el-form-item>
          <el-form-item label="银行帐号" prop="bankCard">
            <el-input
              v-model="addModel.bankCard"
              placeholder="请输入银行帐号"
            ></el-input>
          </el-form-item>
          <el-form-item label="电话" prop="bankPhone">
            <el-input
              v-model="addModel.bankPhone"
              placeholder="请输入电话"
            ></el-input>
          </el-form-item>
          <el-form-item label="发票类型" prop="billingType">
            <el-radio-group v-model="addModel.billingType">
              <el-radio label="GENERAL">普票</el-radio>
              <el-radio label="SPECIAL">专票</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addModel.flag = false">取 消</el-button>
        <el-button class="btn_style" type="primary" @click="sureAdd"
          >确 认</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { invoiceTitleApi, invoiceTitleEditApi } from "../../api/index";
export default {
  data() {
    return {
      filterData: {
        verifyStatus: "",
      },
      tableData: [],
      options: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "VERIFYING",
          label: "未审核",
        },
        {
          value: "SUCCESS",
          label: "通过",
        },
        {
          value: "FAIL",
          label: "不通过",
        },
      ],
      pageInfo: {
        pageNo: 1,
        pageSize: 10,
        total: 0,
      },
      loading: false,
      addModel: {
        flag: false,
        companyName: "companyName",
        licenseCode: "licenseCode",
        companyAddress: "companyAddress",
        bankName: "bankName",
        bankCard: "",
        bankPhone: "",
        billingType: "GENERAL",
      },
    };
  },
  created() {},
  mounted() {
    this.getInfo(1);
  },
  methods: {
    changePage(page) {
      this.pageInfo.pageNo = page;
      this.getInfo(this.pageInfo.pageNo);
    },
    getInfo(page = 1) {
      this.pageInfo.pageNo = page;
      if (this.loading) {
        return;
      }
      this.loading = true;
      invoiceTitleApi({
        pageNo: this.pageInfo.pageNo,
        pageSize: this.pageInfo.pageSize,
        verifyStatus: this.filterData.verifyStatus,
      })
        .then((res) => {
          if (res.resultStatus) {
            this.tableData = res.resultData.invoiceTitleList || [];
            this.pageInfo.total = res.resultData.totalNum || 0;
          } else {
            this.tableData = [];
            this.pageInfo.total = 0;
            this.$message.warning(res.errorMessage);
          }
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(()=>{
          this.loading = false
        })
    },
    toEdit(data) {
      this.addModel = {
        flag: true,
        invoiceTitleId: data.invoiceTitleId,
        companyName: data.companyName,
        licenseCode: data.licenseCode,
        companyAddress: data.companyAddress,
        bankName: data.bankName,
        bankCard: data.bankCard,
        bankPhone: data.bankPhone,
        billingType: data.billingType,
      };
    },
    sureEdit() {
      invoiceTitleEditApi(
        {
          invoiceTitleId: this.addModel.invoiceTitleId,
        },
        {
          companyName: this.addModel.companyName,
          licenseCode: this.addModel.licenseCode,
          companyAddress: this.addModel.companyAddress,
          bankName: this.addModel.bankName,
          bankCard: this.addModel.bankCard,
          bankPhone: this.addModel.bankPhone,
          billingType: this.addModel.billingType,
        }
      )
        .then((res) => {
          if (res.resultStatus) {
            this.$message.success("编辑发票抬头成功");
            this.addModel.flag = false;
          } else {
            this.addModel.flag = false;
          }
        })
        .finally(() => {
          this.getInfo(1);
        });
    },
  },
};
</script>

<style lang="less">
.invoiceTitle_page {
  width: 100%;
  min-height: 100%;
  border: 1px solid #e1e1e1;
  padding: 20px;
  box-sizing: border-box;
  .title_box {
    margin-bottom: 12px;
  }
  .width200 {
    width: 200px;
  }
  .width150 {
    width: 150px;
  }
  .content_box {
    width: 100%;
    box-sizing: border-box;
    .table_content {
      width: 100%;
      box-sizing: border-box;
    }
    .statics {
      font-size: 14px;
      font-weight: bold;
      margin-top: 12px;
    }
  }
  .price {
    color: #00a0e9;
  }
}
.el-tabs__item {
  color: #999;
}
.el-tabs__item:hover {
  color: #00a0e9;
}
.el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  border: 1px solid #2f4050;
  border-bottom: 0;
}
.el-tabs__item.is-active {
  color: #000000;
}
</style>